// Single owner of the "not authenticated -> login, preserving intended URL" redirect.
// Both ProtectedRoute and PermissionRoute render this so they cannot drift.

import { Navigate, useLocation } from 'react-router-dom';

export default function RedirectToLogin() {
  const location = useLocation();
  return <Navigate to="/auth" state={{ from: location }} replace />;
}
